// extracted by mini-css-extract-plugin
export var clickableWrapper = "_37-2";
export var placeholderIcon = "_37-3";
export var thumbnailCanvas = "_37-1";
export var thumbnailWrapper = "_37-0";